export const IS_FUTURA = import.meta.env.VITE_IS_FUTURA === 'true'
